module.exports = __webpack_public_path__ + "static/media/lock_open.64345cef.svg";